export const VIEW_AS_APP_BAR_HEIGHT = 56
